import { User as OidcUser} from 'oidc-client';
export interface ConnectedUser {
    connectionId: string;
    isActive: boolean;
    name: string;
    shortName: string;
    color: string;
}

export interface UserActivity {
    action: string;
    user: ConnectedUser;
    timestamp: string;
}

export interface UsersUpdate {
    users: ConnectedUser[];
}

export interface IUser {
    isEmployee?: boolean;
    permissions?: Permissions[];
    user?: OidcUser;
    role?: Role;
}

export enum Role {
    None = 0,
    User = 1,
    Admin = 2,
    Owner = 3,
    AccountAdmin = 4,
    ExternalUser = 5,
    TextEditor = 6,
    Designer = 7,
    TextEditorExtended = 8,
    UserWithoutAccessOthersContent = 9,
    Publisher = 10,
    Analyzer = 11,
    TextEditorWithAnalyzer = 12,
    PublisherExtended = 13
}

/**
 * Permissions defined in AccountManager on an account level
 */
export type Permissions =
    | 'AccessOthersContent'
    | 'Actions'
    | 'AdvancedFormats'
    | 'AllowHeavyVideos'
    | 'Analytics'
    | 'AnalyticsDemoData'
    | 'Analyzer'
    | 'Approve'
    | 'BannerflowLibrary'
    | 'BannersetDoneMark'
    | 'BannerSetDuplicate'
    | 'CreativesetDoneMark'
    | 'CreativesetDuplicate'
    | 'Comments'
    | 'ConversionTracking'
    | 'Creator'
    | 'CustomAssets'
    | 'CustomBannerScript'
    | 'CustomCreativecript'
    | 'DeleteComments'
    | 'DirectPublishing'
    | 'DownloadButton'
    | 'DuplicateTo'
    | 'Editor'
    | 'EditorKeyFrames'
    | 'EmailMarketing'
    | 'ExternalTranslations'
    | 'Facebook'
    | 'FallbackSharpness'
    | 'Feeds'
    | 'FeedsAutomated'
    | 'FeedsLive'
    | 'KeyframeAnimations'
    | 'LandingPage'
    | 'Lock'
    | 'Marketplace'
    | 'MediaBuyer'
    | 'MediaBuyerPublish'
    | 'MessageSystem'
    | 'MultipleBrands'
    | 'MultipleUsers'
    | 'OpenApi'
    | 'OutdoorFormats'
    | 'Publisher'
    | 'RequirePasswordForNewBrands'
    | 'Scheduling'
    | 'Settings'
    | 'Share'
    | 'SocialMedia'
    | 'Store'
    | 'Studio'
    | 'TextEditor'
    | 'ThemeEnterprise'
    | 'TrackingPixels'
    | 'VideoConverter'
    | 'ExportHtmlFromStudio'
    | 'StudioVideoLibrary'
    | 'SocialCampaignManager';
